import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Typography } from "@mui/material";

import VisaIcon from "../Icons/VisaIcon";
import AmexIcon from "../Icons/AmexIcon";
import PaypalIcon from "../Icons/PaypalIcon";
import DiscoverIcon from "../Icons/DiscoverIcon";
import MasterCardIcon from "../Icons/MasterCardIcon";

const PaymentMethods = () => {
  const { t } = useTranslation();

  return (
    <Stack gap="8px">
      <Typography color="white" variant="body1">
        {t("footer.accepted_payment_methods")}
      </Typography>
      <Stack direction="row" gap="18px">
        <VisaIcon />
        <AmexIcon />
        <DiscoverIcon />
        <MasterCardIcon />
        <PaypalIcon />
      </Stack>
    </Stack>
  );
};

export default PaymentMethods;
